<template>
  <ul
    ref="dropDownMenu"
    :class="['dropdown', align]">
    <button
      id="dropdownMenuButton1"
      class="o-link-arrow down"
      :aria-expanded="show"
      type="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      @keyup.tab="onClick"
      @click.prevent="onClick">
      <span data-wptv="dropdown-label">{{ label }}</span>
    </button>
    <div
      v-show="show"
      v-if="format === 'button'"
      class="dropdown-menu"
      x-placement="bottom-start">
      <li
        v-for="(item, index) in items"
        :key="item.label"
        :aria-selected="selectedItem === item"
        :class="['dropdown-item', { 'disabled': item.disabled, 'active' : selectedItem === item }]"
        type="button"
        @keydown.tab.exact="onBlur(index)"
        @click="updateValue(item)">
        <span data-wptv="dropdown-button-label">{{ item.label }}</span>
      </li>
    </div>
    <div
      v-show="show"
      v-else
      class="dropdown-menu"
      x-placement="bottom-start"
      :aria-labelledby="label">
      <li
        v-for="(item, index) in items"
        :key="item.label"
        :aria-selected="selectedItem === item"
        :class="['dropdown-item', { 'disabled': item.disabled, 'active' : selectedItem === item }]">
        <a
          :href="item.value"
          @keydown.tab.exact="onBlur(index)"
          @click="updateValue(item)">
          <span data-wptv="dropdown-button-label">{{ item.label }}</span>
        </a>
      </li>
    </div>
  </ul>
</template>

<script>
const formats = ['button', 'link']
const align = ['left', 'right']
export default {
  name: 'WptvDropdown',
  props: {
    defaultValue: {
      type: Object,
      default: () => {}
    },
    items: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      required: true,
      default: ''
    },
    format: {
      type: String,
      default: 'button',
      validator: (value) => {
        return formats.includes(value)
      }
    },
    align: {
      type: String,
      required: true,
      validator: (value) => {
        return align.includes(value)
      }
    },
    enableDefaultSelected: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      show: false,
      selectedItem: null
    }
  },
  watch: {
    defaultValue (value) {
      this.selectedItem = value
    }
  },
  mounted () {
    window.addEventListener('click', (e) => {
      if (this.$refs.dropDownMenu && !this.$refs.dropDownMenu.contains(e.target)) {
        this.show = false
      }
    })

    this.selectedItem = this.enableDefaultSelected ? (this.defaultValue || this.items[0]) : null
  },
  beforeDestroy () {
    window.removeEventListener('click', (e) => {
      if (this.$refs.dropDownMenu && !this.$refs.dropDownMenu.contains(e.target)) {
        this.show = false
      }
    })
  },
  methods: {
    // called on tab on the items of the dropdown (not on shift + tab)
    onBlur (i) {
      // close the dropdown if we tab from the last item
      if (i === this.items.length - 1) {
        this.show = false
      }
    },
    onClick () {
      this.show = !this.show
    },
    updateValue (value) {
      this.selectedItem = value
      this.$emit('input', value)
      this.show = !this.show
    },
    resetValue () {
      this.selectedItem = null
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown {
  display: inline-flex;
  position: relative;
  height: 34px;

  .dropdown-menu {
    display: block;
    margin-top: 10px;

    li {
      cursor: pointer;
    }
  }

  .o-link-arrow::after {
    position: relative;
  }

  &.right {
    .dropdown-menu {
      right: 0;
      left: auto;
    }
  }
}
</style>
